import ProductCatalog from '@/features/pos/components/ProductCatalog'
import ConfigurableContainerProvider from '@/features/pos/contexts/ConfigurableContainer'
import ConfigurableProductIdProvider from '@/features/pos/contexts/ConfigurableProductId'
import { FC } from 'react'

const ProductCatalogPage: FC = () => {
    return (
        <ConfigurableProductIdProvider>
            <ConfigurableContainerProvider>
                <ProductCatalog />
            </ConfigurableContainerProvider>
        </ConfigurableProductIdProvider>
    )
}

export default ProductCatalogPage
